import styled from "styled-components";

interface Props {
  marginBottom?: string;
}
export const AdviceWrapper = styled.div<Props>`
  display: flex;
  justify-content: left;
  margin-bottom: ${({ marginBottom }) => marginBottom ?? "0"};
`;
